<template>
  <div class="registerFloat loginFloat">
    <dialogTem  :visible.sync="showBindphone"  :diaTitle="$t('dialog.login')" 
    :types="'phone'" :diaWidth="'320px'" @handleCloseDialog="()=>setshowBindphone(false)">
      <div class="login-body">
        <div class="box-left">
          <el-form
            class="form-horizontal newform phone"
            ref="ruleForm"
            label-width="100px"
            :model="phoneForm"
            :rules="rules"
            label-position="top"
            :hide-required-asterisk="true"
          >
            <el-form-item prop="phone" :label="$t('dialogphone.phone')">
                <span>+91</span>
                <!-- <input type="text" v-model="phoneForm.phone" @keyup.enter="submitForm('ruleForm')"> -->
                <el-input v-model="phoneForm.phone" 
              autocomplete="off" :max="12" class="icon_password"
              @keyup.enter="submitForm('ruleForm')"
              >
              
              </el-input>
            </el-form-item>
            <el-form-item class="btn-group">
              <el-button
                :loading="isReady"
                type="primary"
                @click="submitForm('ruleForm')"
                @keyup.enter.native="submitForm('ruleForm')"
                class="_reg_now"
              >{{$t('dialogphone.Confirm')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tips">
        <p>
            {{$t('dialogphone.tips')}}
        </p>
        <li>
            {{$t('dialogphone.tips2')}}
        </li>
        <li>
            {{$t('dialogphone.tips3')}}
        </li>
      </div>
    </dialogTem>
  </div>
</template>

<script>
import dialogTem from '../dialogTem.vue'
import { INcheck } from "@/common/index";
import { validateophone } from '../../utils/validate'
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  inject:['parentRoot'],
  components:{ dialogTem },
  data() {
    return {
      flag:true,
      phoneForm: {
        phone: "",
        phoneYzm: "",
      },
      checked: false,
      isReady: false,
      rules: validateophone(this),
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      showBindphone: (state) => state.showBindphone,
      appJump: (state) => state.linkList.appJump,
    }),
  },
  methods: {
    ...mapMutations(["setshowloginfloat", "setshowBindphone"]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "Login","getFirstInfo"]),
    _notifyFun(title,type,message,Ready){ // 提示语
      this.isReady = Ready;
      this.$notify({ duration: 8000,title:this.$t(title), message:message, type:type,});
    },
    checkPhoneNumberAction() {
        let isOK = true;
        let phone = INcheck.checkPhone((this.phoneForm.phone).replace(/(^\s*)|(\s*$)/g, ''));
        // 校验手机号码
        if(phone){
          
          this.$notify({
            title: this.$t('notify.warning'),
            message: this.$t(phone),
            type: "warning",
          });
          isOK = false
          return
        }
        if(this.isPhoneVerify === '1'){
          if(this.phoneForm.phoneYzm==='') {
            this.$notify({
              title: this.$t('notify.warning'),
              message: this.$t('header.checkVrifyCode'),
              type: "warning",
            });
            isOK = false
            return
          }
        }
        return isOK
      },
    submitForm(formName) {
      let isOK = this.checkPhoneNumberAction();
    //   this.$refs[formName].validate((valid) => {
        if (isOK) {
          let params = {
            UUID: this.UUID,
            phone: this.phoneForm.phone,
            phoneYzm: this.phoneForm.phoneYzm,
          };
          this.isReady = true;
          this.$api.post(this.$urls.CONFIRM.confirmPhone,params,resp=>{
            this.isReady = false;
            console.log(resp.data.code)
            if (resp.data.code === undefined) {
              if (resp.data.data.code === 200) {
                this.getFirstInfo();
                this.setshowBindphone(false);
                this.$refs[formName].resetFields();
                this.isReady = false;
                this._notifyFun('notify.success','success',this.$t('mine.verifyPhone.phoneConfrim'),false)
              } else {
                let msg = resp.data.msg ? resp.data.msg : this.$t('mine.safein.common3');
                this._notifyFun('notify.warning','warning',msg,false)
              }
            } else {
                if (resp.data.code === 200) {
                this.getFirstInfo();
                this.setshowBindphone(false);
                this.$refs[formName].resetFields();
                this.isReady = false;
                this._notifyFun('notify.success','success',this.$t('mine.verifyPhone.phoneConfrim'),false)
              } else {
                let msg = resp.data.msg ? resp.data.msg : this.$t('mine.safein.common3');
                this._notifyFun('notify.warning','warning',msg,false)
              }
            }
          },(err) => {
            this._notifyFun('notify.warning','warning',err,false)
          });
        } 
    //   });
    },
  },
  mounted() {

  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
.registerFloat {
  .login-body {
    padding:0px 22px 31px;
    .box-left .el-form {
      .login {
        color: #fff;
        text-align: center;
        cursor: pointer;
        padding-bottom: 15px;
      }
      &.phone{
        .el-form-item {
        margin-bottom:0px!important;
        width: 100%;
        display: inline-block;
        &.btn-group{ margin-bottom:0!important;}
        /deep/ .el-form-item__label{
            padding:0;
            color: #fff;
            font-size:18px;
        }
        /deep/ .el-form-item__content{
            height:44px;
            display: flex;
            // justify-content: center;
            align-items: center;
            .el-input{
                .el-input__inner{
                    background-color: #fff;
                    border-radius:6px;
                    line-height:44px;
                    height:44px;
                    width:100%;
                    padding:0 0 0 15px !important;
                    border: 0; 
                    outline: none;
                }
            }
        }
        span{
            padding:0 20px;
            margin-right:5px;
            height:100%;
            border-radius:6px;
            color: gray;
            background-color: #fff;
            font-weight:600;
            font-size:18px;
            line-height:44px;
            width: 90px;
        }
        .el-button{
            margin:30px 0 0 ;
        }
      }
      }
    }
    ._gosingup_btn{
      width:100%;
      background-color: #d2ffdb;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
      margin-top:10px;
      line-height: 48px;
      cursor: pointer;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 600;
      color: #222;
      text-align: center;
    }
    // .forgetPosword{
    //   cursor: pointer;
    //   font-family: ArialMT;
    //   font-size: 20px;
    //   font-weight: normal;
    //   font-stretch: normal;
    //   line-height: 50px;
    //   letter-spacing: 0px;
    //   color: #323232;
    //   text-align: center;
    // }
  }
  .tips{
    padding:0 20px 40px;
    color: #fff;
    p{
        padding:15px 0;
    }
    li{
        padding-left:10px;
    }
  }
  .fresh_ico{
    display: inline-block; width: 19px; height: 20px; background: url(../img/fresh_ico.png) no-repeat; vertical-align: middle; cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build901/components/common/register/phone.vue